import React from 'react';
import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';

const Portfolio = () => {
  const projects = [
    {
      title: "Electrical Listbuilder",
      description: "A utility for electricians to create and manage lists of materials for electrical projects.",
      technologies: ["Xamarin.Forms", "C#", "Mobile App"],
      appStoreUrl: "https://apps.apple.com/gb/app/electrical-listbuilder/id1551698180",
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.ronaldobutrus.electricallistbuilder",
      imageUrl: "/ElectricalListbuilder/appIcon.png"
    },
    {
      title: "RonWork",
      description: "A productivity app to help manage homework and timetabling.",
      technologies: ["Xamarin.Forms", "C#", "Mobile App"],
      appStoreUrl: "https://apps.apple.com/gb/app/ronwork/id1603694943",
      playStoreUrl: "https://play.google.com/store/apps/details?id=com.ronaldobutrus.ronwork",
      imageUrl: "/RonWork/appIcon.png"
    },
    {
      title: "QuoteKeys",
      description: "An app designed to provide users with insightful quotes and a customised keyboard experience.",
      technologies: ["iOS", "Swift", "Mobile App"],
      appStoreUrl: "https://apps.apple.com/gb/app/quotekeys/id6463052510",
      imageUrl: "/QuoteKeys/appIcon.png"
    },
    {
      title: "RonRunner",
      description: "A reliable and simple interval run/exercise timer. It provides a beep halfway and a three-second countdown, letting you focus on your exercise.",
      technologies: ["iOS", "SwiftUI", "Health & Fitness", "Mobile App"],
      appStoreUrl: "https://apps.apple.com/gb/app/ronrunner/id6461868133",
      imageUrl: "/RonRunner/appIcon.png"
    }
  ];

  const otherThings = [
    {
      title: "Colour Generator",
      description: "A simple colour generator tool.",
      link: "/Site1/index.html",
      technologies: ["Web Assembly", "JavaScript"]
    },
    {
      title: "Bingo",
      description: "A bingo game.",
      link: "/Site2/index.html",
      technologies: ["JavaScript"]
    },
    {
      title: "Pygame Installer",
      description: "Instructions for installing Pygame.",
      link: "/Site3/index.html",
      technologies: ["Python", "Pygame"]
    },
    {
        title: "Bingo (Qt)",
        description: "A bingo game built with Qt.",
        link: "/Site4/index.html",
        technologies: ["Web Assembly", "Qt", "C++"]
    }
  ];

  const blenderWork = {
    title: "3D Character Sculpting",
    description: "A relatively basic sculpt of my head made using Blender, showcasing skills learned from 30+ hours of training in hard-surface modeling, sculpting, UV unwrapping, baking, painting, retopology, animation and rendering.",
    technologies: ["Blender", "3D Modeling", "Sculpting", "Rendering"],
    videos: [
      {
        title: "Rendered with Eevee",
        url: "/Ronaldo_Eevee.mp4"
      },
      {
        title: "Rendered with Cycles", 
        url: "/Ronaldo_Cycles.mp4"
      }
    ]
  };

  return (
    <Container className="py-5">
      <h1 className="pb-2 mb-4">
        <i className="bi bi-collection-fill"></i> Portfolio
      </h1>
      
      <Row xs={1} md={2} className="g-4">
        {projects.map((project, index) => (
          <Col key={index}>
            <Card className="h-100 shadow-sm">
              <Card.Header className="d-flex align-items-center">
                <img src={project.imageUrl} alt={`${project.title} icon`} className="rounded me-3" style={{ width: '55px', height: '55px' }} />
                <h5 className="mb-0 fw-bold text-primary">{project.title}</h5>
              </Card.Header>
              <Card.Body>
                <p className="text-dark">{project.description}</p>
                <div className="mb-3">
                  {project.technologies.map((tech, techIndex) => (
                    <Badge key={techIndex} pill bg="info" text="dark" className="me-1 mb-1 fw-normal">
                      {tech}
                    </Badge>
                  ))}
                </div>
              </Card.Body>
              <Card.Footer className="bg-white border-top-0">
                <div className="d-flex justify-content-start">
                  {project.appStoreUrl && project.appStoreUrl !== "#" &&
                    <a href={project.appStoreUrl} target="_blank" rel="noopener noreferrer" className="me-2">
                      <img src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg" alt="Download on the App Store" height="40" />
                    </a>
                  }
                  {project.playStoreUrl &&
                    <a href={project.playStoreUrl} target="_blank" rel="noopener noreferrer">
                      <img src="https://lh3.googleusercontent.com/cjsqrWQKJQp9RFO7-hJ9AfpKzbUb_Y84vXfjlP0iRHBvladwAfXih984olktDhPnFqyZ0nu9A5jvFwOEQPXzv7hr3ce3QVsLN8kQ2Ao=s0" alt="Get it on Google Play" height="40" />
                    </a>
                  }
                </div>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>

      <h2 className="pb-2 mt-5 mb-4 border-top pt-5">
        <i className="bi bi-camera-video-fill"></i> 3D Modeling & Animation
      </h2>

      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Header as="h5" className="fw-bold text-primary">{blenderWork.title}</Card.Header>
            <Card.Body>
              <p className="text-dark">{blenderWork.description}</p>
              <div className="mb-3">
                {blenderWork.technologies.map((tech, techIndex) => (
                  <Badge key={techIndex} pill bg="warning" text="dark" className="me-1 mb-1 fw-normal">
                    {tech}
                  </Badge>
                ))}
              </div>
              <div className="d-flex flex-wrap gap-2">
                {blenderWork.videos.map((video, index) => (
                  <Button 
                    key={index} 
                    variant="outline-success" 
                    href={video.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="d-flex align-items-center"
                  >
                    <i className="bi bi-play-circle me-2"></i>
                    {video.title}
                  </Button>
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <h2 className="pb-2 mt-5 mb-4 border-top pt-5">
        <i className="bi bi-box-fill"></i> Miscellaneous School Projects
      </h2>

      <Row xs={1} md={2} lg={4} className="g-4">
        {otherThings.map((item, index) => (
          <Col key={index}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Title as="h5" className="fw-bold text-primary">{item.title}</Card.Title>
                <Card.Text className="flex-grow-1">{item.description}</Card.Text>
                <div>
                  {item.technologies.map((tech, techIndex) => (
                    <Badge key={techIndex} pill bg="secondary" text="white" className="me-1 mb-1 fw-normal">
                      {tech}
                    </Badge>
                  ))}
                </div>
              </Card.Body>
              <Card.Footer className="bg-white border-top-0">
                <Button variant="outline-primary" href={item.link} target="_blank" rel="noopener noreferrer">
                  View Project
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>

    </Container>
  );
};

export default Portfolio; 